module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "navbar navbar-inverse"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('p', {
    staticClass: "navbar-text navbar-left"
  }, [(!_vm.generalObj.IsLocked) ? [_vm._v("Add")] : [_vm._v("Preview")], _vm._v(" PGNAT Project\n      ")], 2), _vm._v(" "), _c('div', {
    staticClass: "navbar-right navbar-form"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    class: {
      'hide-on-preview': _vm.generalObj.IsLocked
    },
    on: {
      "click": _vm.saveProject
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.projectID === 0
    },
    on: {
      "click": _vm.testProject
    }
  }, [_vm._v("\n          Test\n        ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": ("/?cipID=" + (this.cipID)),
      "activeClass": "active",
      "tag": "a"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("Back")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-info configurePanel",
    class: {
      'configurePanel--preview': _vm.generalObj.IsLocked
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Project Name ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.generalObj.projectName),
      expression: "generalObj.projectName"
    }],
    staticClass: "col-md-12",
    attrs: {
      "type": "text",
      "placeholder": "eg: Expedia DBA"
    },
    domProps: {
      "value": (_vm.generalObj.projectName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.generalObj, "projectName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Test Brand / Concept ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.generalObj.testBrand),
      expression: "generalObj.testBrand"
    }],
    staticClass: "col-md-12",
    attrs: {
      "type": "text",
      "placeholder": "eg: Expedia"
    },
    domProps: {
      "value": (_vm.generalObj.testBrand)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.generalObj, "testBrand", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Exercise Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.generalObj.exerciseType),
      expression: "generalObj.exerciseType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.generalObj, "exerciseType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Select exercist type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Ad Test"
    }
  }, [_vm._v("Ad Test")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Brand / Ad Tracker"
    }
  }, [_vm._v("Brand / Ad Tracker")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Brand Positioning"
    }
  }, [_vm._v("Brand Positioning")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Claims / Positioning Test"
    }
  }, [_vm._v("\n              Claims / Positioning Test\n            ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Concept Test"
    }
  }, [_vm._v("Concept Test")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Distinctive Brand Asset"
    }
  }, [_vm._v("\n              Distinctive Brand Asset\n            ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MarketSpex"
    }
  }, [_vm._v("MarketSpex")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Name Test"
    }
  }, [_vm._v("Name Test")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pack Test"
    }
  }, [_vm._v("Pack Test")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Shopper Based Design"
    }
  }, [_vm._v("Shopper Based Design")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "U&A"
    }
  }, [_vm._v("U&A")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Language")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.generalObj.language),
      expression: "generalObj.language"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.generalObj, "language", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select language")]), _vm._v(" "), _vm._l((_vm.sortedLanguages), function(lang) {
    return _c('option', {
      key: lang,
      domProps: {
        "value": lang
      }
    }, [_vm._v("\n            " + _vm._s(lang) + "\n            ")])
  })], 2)])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.generalObj.primeDuration),
      expression: "generalObj.primeDuration"
    }],
    staticClass: "col-md-12",
    attrs: {
      "type": "text",
      "disabled": !_vm.editableFieldsControl.primeDuration
    },
    domProps: {
      "value": (_vm.generalObj.primeDuration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.generalObj, "primeDuration", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "edit-field-icon",
    class: {
      'is-disabled': _vm.editableFieldsControl.primeDuration
    },
    on: {
      "click": function($event) {
        return _vm.openConfirmationModal('Prime Duration', 'primeDuration')
      }
    }
  }, [_c('div', {
    staticClass: "edit-field-icon__title"
  }, [_vm._v("Edit field")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.generalObj.testDuration),
      expression: "generalObj.testDuration"
    }],
    staticClass: "col-md-12",
    attrs: {
      "type": "text",
      "disabled": !_vm.editableFieldsControl.testDuration
    },
    domProps: {
      "value": (_vm.generalObj.testDuration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.generalObj, "testDuration", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "edit-field-icon",
    class: {
      'is-disabled': _vm.editableFieldsControl.testDuration
    },
    on: {
      "click": function($event) {
        return _vm.openConfirmationModal('Test Duration', 'testDuration')
      }
    }
  }, [_c('div', {
    staticClass: "edit-field-icon__title"
  }, [_vm._v("Edit field")])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.generalObj.feedbackDuration),
      expression: "generalObj.feedbackDuration"
    }],
    staticClass: "col-md-12",
    attrs: {
      "type": "text",
      "disabled": !_vm.editableFieldsControl.feedbackDuration
    },
    domProps: {
      "value": (_vm.generalObj.feedbackDuration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.generalObj, "feedbackDuration", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "edit-field-icon",
    class: {
      'is-disabled': _vm.editableFieldsControl.feedbackDuration,
    },
    on: {
      "click": function($event) {
        return _vm.openConfirmationModal('Feedback Duration', 'feedbackDuration')
      }
    }
  }, [_c('div', {
    staticClass: "edit-field-icon__title"
  }, [_vm._v("Edit field")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.generalObj.blankInterval),
      expression: "generalObj.blankInterval"
    }],
    staticClass: "col-md-12",
    attrs: {
      "type": "text",
      "disabled": !_vm.editableFieldsControl.blankInterval
    },
    domProps: {
      "value": (_vm.generalObj.blankInterval)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.generalObj, "blankInterval", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "edit-field-icon",
    class: {
      'is-disabled': _vm.editableFieldsControl.blankInterval
    },
    on: {
      "click": function($event) {
        return _vm.openConfirmationModal('Blank Interval', 'blankInterval')
      }
    }
  }, [_c('div', {
    staticClass: "edit-field-icon__title"
  }, [_vm._v("Edit field")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-info configurePanel",
    class: {
      'configurePanel--preview': _vm.generalObj.IsLocked
    }
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("\n        Prime (i.e. asset, brand name or logo, packaging)\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "btnContainer"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    class: {
      'hide-on-preview': _vm.generalObj.IsLocked
    },
    on: {
      "click": _vm.addMoreAssets
    }
  }, [_vm._v("\n          Add More Assets\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Prime Assignment (awareness/familiarity)")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.primeAssignment),
      expression: "primeAssignment"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.primeAssignment = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Select Prime Assignment")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "No assignment, fell out naturally"
    }
  }, [_vm._v("No assignment, fell out naturally")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Based on aware/familiar of assigned"
    }
  }, [_vm._v("Based on aware/familiar of assigned")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Based on aware/familiar of all"
    }
  }, [_vm._v("Based on aware/familiar of all")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Based on aware/familiar of some"
    }
  }, [_vm._v("Based on aware/familiar of some")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other"
    }
  }, [_vm._v("Other")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Pre-exposure Format Type:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preExposureFormatType),
      expression: "preExposureFormatType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.preExposureFormatType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Select Pre-exposure Format")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "None"
    }
  }, [_vm._v("None")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Video"
    }
  }, [_vm._v("Video")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Text"
    }
  }, [_vm._v("Text")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Image"
    }
  }, [_vm._v("Image")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Text and Image"
    }
  }, [_vm._v("Text and Image")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Shelf (small- under 50 SKUs)"
    }
  }, [_vm._v("Shelf (small- under 50 SKUs)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Shelf (medium 50-100 SKUs)"
    }
  }, [_vm._v("Shelf (medium 50-100 SKUs)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Shelf (large > 100 SKUs)"
    }
  }, [_vm._v("Shelf (large > 100 SKUs)")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 text-center"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Set Prime Type for ALL:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isAllSelected),
      expression: "isAllSelected"
    }],
    staticClass: "center-block",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isAllSelected) ? _vm._i(_vm.isAllSelected, null) > -1 : (_vm.isAllSelected)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isAllSelected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isAllSelected = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isAllSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isAllSelected = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAllSelected == true),
      expression: "isAllSelected == true"
    }],
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Select Prime Type for ALL:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assetAllType),
      expression: "assetAllType"
    }],
    staticClass: "col-md-12",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.assetAllType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.onAllTypeSelected($event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Select Prime Type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Assets (Client)"
    }
  }, [_vm._v("Assets (Client)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Assets (Competitors)"
    }
  }, [_vm._v("Assets (Competitors)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Logos (Client, Competitors)"
    }
  }, [_vm._v("Logos (Client, Competitors)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Packages (Current Client, Competitors)"
    }
  }, [_vm._v("Packages (Current Client, Competitors)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Packages (Current Client, Test Packs, Competitors)"
    }
  }, [_vm._v("Packages (Current Client, Test Packs, Competitors)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Packages (Test Pack, Competitors)"
    }
  }, [_vm._v("Packages (Test Pack, Competitors)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Packages (Current Client)"
    }
  }, [_vm._v("Packages (Current Client)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Packages (Competitors)"
    }
  }, [_vm._v("Packages (Competitors)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Packages (Test Pack)"
    }
  }, [_vm._v("Packages (Test Pack)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Debranded Packages (Current Client, Competitors)"
    }
  }, [_vm._v("Debranded Packages (Current Client, Competitors)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Debranded Packages (Test Packs, Competitors)"
    }
  }, [_vm._v("Debranded Packages (Test Packs, Competitors)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Debranded Packages (Current Client)"
    }
  }, [_vm._v("Debranded Packages (Current Client)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Debranded Packages (Test Pack)"
    }
  }, [_vm._v("Debranded Packages (Test Pack)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Debranded Packages (Competitors)"
    }
  }, [_vm._v("Debranded Packages (Competitors)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Category (Different Exemplars)"
    }
  }, [_vm._v("Category (Different Exemplars)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Category (Different Occasions)"
    }
  }, [_vm._v("Category (Different Occasions)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Functional Attributes"
    }
  }, [_vm._v("Functional Attributes")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Names"
    }
  }, [_vm._v("Names")])])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._l((_vm.brandAssets), function(asset, index) {
    return _c('div', {
      key: index,
      staticClass: "assetEntries"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (asset.assetDesc),
        expression: "asset.assetDesc"
      }],
      staticClass: "col-md-12",
      attrs: {
        "type": "text",
        "placeholder": "eg: Tide Logo"
      },
      domProps: {
        "value": (asset.assetDesc)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(asset, "assetDesc", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (asset.assetURL),
        expression: "asset.assetURL"
      }],
      staticClass: "col-md-12",
      attrs: {
        "type": "text",
        "placeholder": "eg: url link for Tide logo"
      },
      domProps: {
        "value": (asset.assetURL)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(asset, "assetURL", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (asset.assetPrimeType),
        expression: "asset.assetPrimeType"
      }],
      staticClass: "col-md-12",
      attrs: {
        "id": "testDisabled",
        "disabled": _vm.isAllSelected
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(asset, "assetPrimeType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "",
        "selected": "",
        "disabled": ""
      }
    }, [_vm._v("Select Prime Type")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Assets (Client)"
      }
    }, [_vm._v("Assets (Client)")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Assets (Competitors)"
      }
    }, [_vm._v("Assets (Competitors)")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Logos (Client, Competitors)"
      }
    }, [_vm._v("Logos (Client, Competitors)")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Packages (Current Client, Competitors)"
      }
    }, [_vm._v("Packages (Current Client, Competitors)")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Packages (Current Client, Test Packs, Competitors)"
      }
    }, [_vm._v("Packages (Current Client, Test Packs, Competitors)")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Packages (Test Pack, Competitors)"
      }
    }, [_vm._v("Packages (Test Pack, Competitors)")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Packages (Current Client)"
      }
    }, [_vm._v("Packages (Current Client)")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Packages (Competitors)"
      }
    }, [_vm._v("Packages (Competitors)")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Packages (Test Pack)"
      }
    }, [_vm._v("Packages (Test Pack)")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Debranded Packages (Current Client, Competitors)"
      }
    }, [_vm._v("Debranded Packages (Current Client, Competitors)")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Debranded Packages (Test Packs, Competitors)"
      }
    }, [_vm._v("Debranded Packages (Test Packs, Competitors)")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Debranded Packages (Current Client)"
      }
    }, [_vm._v("Debranded Packages (Current Client)")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Debranded Packages (Test Pack)"
      }
    }, [_vm._v("Debranded Packages (Test Pack)")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Debranded Packages (Competitors)"
      }
    }, [_vm._v("Debranded Packages (Competitors)")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Category (Different Exemplars)"
      }
    }, [_vm._v("Category (Different Exemplars)")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Category (Different Occasions)"
      }
    }, [_vm._v("Category (Different Occasions)")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Functional Attributes"
      }
    }, [_vm._v("Functional Attributes")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Names"
      }
    }, [_vm._v("Names")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-1 text-center"
    }, [_c('button', {
      staticClass: "btn btn-xs btn-warning",
      class: {
        'hide-on-preview': _vm.generalObj.IsLocked
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deletePrime(asset.assetID, index)
        }
      }
    }, [_vm._v("\n            x\n          ")])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-info configurePanel",
    class: {
      'configurePanel--preview': _vm.generalObj.IsLocked
    }
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Client URL Description ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.principle.clientDesc),
      expression: "principle.clientDesc"
    }],
    staticClass: "col-md-12",
    attrs: {
      "type": "text",
      "placeholder": "eg: Expedia LOGO"
    },
    domProps: {
      "value": (_vm.principle.clientDesc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.principle, "clientDesc", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Client Image URL ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.principle.clientURL),
      expression: "principle.clientURL"
    }],
    staticClass: "col-md-12",
    attrs: {
      "type": "text",
      "rows": "1",
      "placeholder": "eg: https://s3.amazonaws.com/eusimage.hotspex.com/Projects/312801/expedia_dba/Med/cell1-image1.jpg"
    },
    domProps: {
      "value": (_vm.principle.clientURL)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.principle, "clientURL", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Competitve URL Description ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.principle.competitiveDesc),
      expression: "principle.competitiveDesc"
    }],
    staticClass: "col-md-12",
    attrs: {
      "type": "text",
      "placeholder": "eg: Aribnb LOGO"
    },
    domProps: {
      "value": (_vm.principle.competitiveDesc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.principle, "competitiveDesc", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Competitve Image URL ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.principle.competitiveURL),
      expression: "principle.competitiveURL"
    }],
    staticClass: "col-md-12",
    attrs: {
      "type": "text",
      "rows": "1",
      "placeholder": "eg: https://s3.amazonaws.com/eusimage.hotspex.com/Projects/312801/expedia_dba/Med/cell2-image1.jpg"
    },
    domProps: {
      "value": (_vm.principle.competitiveURL)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.principle, "competitiveURL", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-info configurePanel",
    class: {
      'configurePanel--preview': _vm.generalObj.IsLocked
    }
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("\n        Associate Target (i.e. personality or emotional dimensions)\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "btnContainer"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    class: {
      'hide-on-preview': _vm.generalObj.IsLocked
    },
    on: {
      "click": _vm.addMoreCategoryAssets
    }
  }, [_vm._v("\n          Add Attribute\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, _vm._l((_vm.categoryAssets), function(category, i) {
    return _c('div', {
      key: i,
      staticClass: "col-md-6 category1"
    }, [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("Category Name")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (category.categoryName),
        expression: "category.categoryName"
      }],
      staticClass: "col-md-12",
      attrs: {
        "type": "text",
        "placeholder": "eg: INSPIRATIONAL"
      },
      domProps: {
        "value": (category.categoryName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(category, "categoryName", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("Category Definition")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (category.categoryDesc),
        expression: "category.categoryDesc"
      }],
      staticClass: "col-md-12",
      attrs: {
        "rows": "3",
        "placeholder": "eg: standing out, being unique, new, and thinking outside the box. Please put the content after word 'means'."
      },
      domProps: {
        "value": (category.categoryDesc)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(category, "categoryDesc", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("Attribute Options")]), _vm._v(" "), _vm._l((category.assets), function(attr, index) {
      return _c('div', {
        key: index,
        staticClass: "attributeInput row"
      }, [_c('div', {
        staticClass: "col-md-2"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (attr.assetZone),
          expression: "attr.assetZone"
        }],
        staticClass: "col-md-12",
        attrs: {
          "id": ("selectedZone_" + i + "_" + index)
        },
        on: {
          "change": [function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(attr, "assetZone", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }, function($event) {
            return _vm.onZoneSelected(i, index)
          }]
        }
      }, [_c('option', {
        attrs: {
          "value": "",
          "selected": "",
          "disabled": ""
        }
      }, [_vm._v("Select Zone")]), _vm._v(" "), _c('option', {
        attrs: {
          "data-zoneid": "1",
          "value": "Interesting"
        }
      }, [_vm._v("Interesting")]), _vm._v(" "), _c('option', {
        attrs: {
          "data-zoneid": "2",
          "value": "Fun"
        }
      }, [_vm._v("Fun")]), _vm._v(" "), _c('option', {
        attrs: {
          "data-zoneid": "3",
          "value": "Friendly"
        }
      }, [_vm._v("Friendly")]), _vm._v(" "), _c('option', {
        attrs: {
          "data-zoneid": "4",
          "value": "Nurturing"
        }
      }, [_vm._v("Nurturing")]), _vm._v(" "), _c('option', {
        attrs: {
          "data-zoneid": "5",
          "value": "Familiar"
        }
      }, [_vm._v("Familiar")]), _vm._v(" "), _c('option', {
        attrs: {
          "data-zoneid": "6",
          "value": "Trustworthy"
        }
      }, [_vm._v("Trustworthy")]), _vm._v(" "), _c('option', {
        attrs: {
          "data-zoneid": "7",
          "value": "Knowledgeable"
        }
      }, [_vm._v("Knowledgeable")]), _vm._v(" "), _c('option', {
        attrs: {
          "data-zoneid": "8",
          "value": "Inspiring"
        }
      }, [_vm._v("Inspiring")])])]), _vm._v(" "), _c('div', {
        staticClass: "col-md-2"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (attr.assetRing),
          expression: "attr.assetRing"
        }],
        staticClass: "col-md-12",
        attrs: {
          "id": ("selectedRing_" + i + "_" + index)
        },
        on: {
          "change": [function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(attr, "assetRing", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }, function($event) {
            return _vm.onRingSelected(i, index)
          }]
        }
      }, [_c('option', {
        attrs: {
          "value": "",
          "selected": "",
          "disabled": ""
        }
      }, [_vm._v("Select Ring")]), _vm._v(" "), _c('option', {
        attrs: {
          "data-ringid": "1",
          "value": "Core"
        }
      }, [_vm._v("Core")]), _vm._v(" "), _c('option', {
        attrs: {
          "data-ringid": "2",
          "value": "Differentiator"
        }
      }, [_vm._v("Differentiator")]), _vm._v(" "), _c('option', {
        attrs: {
          "data-ringid": "3",
          "value": "Cusp"
        }
      }, [_vm._v("Cusp")]), _vm._v(" "), _c('option', {
        attrs: {
          "data-ringid": "4",
          "value": "Negative"
        }
      }, [_vm._v("Negative")])])]), _vm._v(" "), _c('div', {
        staticClass: "col-md-3"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (attr.assetDesc),
          expression: "attr.assetDesc"
        }],
        staticClass: "col-md-12",
        attrs: {
          "name": "attributeOption",
          "id": ("selectedAttribute_" + i + "_" + index)
        },
        on: {
          "focus": function($event) {
            return _vm.getAttributeOptions(i, index)
          },
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(attr, "assetDesc", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        attrs: {
          "value": "",
          "selected": "",
          "disabled": ""
        }
      }, [_vm._v("Select Attribute")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "Add New"
        }
      }, [_vm._v("-- ADD NEW --")]), _vm._v(" "), _c('option', {
        attrs: {
          "selected": "",
          "disabled": ""
        },
        domProps: {
          "value": ("" + (attr.assetDesc))
        }
      }, [_vm._v(_vm._s(attr.assetDesc))])])]), _vm._v(" "), (attr.assetDesc === 'Add New') ? _c('div', {
        staticClass: "col-md-4"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model.trim",
          value: (attr.assetDescOther),
          expression: "attr.assetDescOther",
          modifiers: {
            "trim": true
          }
        }],
        staticClass: "col-md-12",
        attrs: {
          "type": "text",
          "id": ("selectedOther_" + i + "_" + index),
          "placeholder": "Please enter new attribute"
        },
        domProps: {
          "value": (attr.assetDescOther)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(attr, "assetDescOther", $event.target.value.trim())
          },
          "blur": function($event) {
            return _vm.$forceUpdate()
          }
        }
      })]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "col-md-1 text-right"
      }, [_c('button', {
        staticClass: "btn btn-xs btn-warning",
        class: {
          'hide-on-preview': _vm.generalObj.IsLocked
        },
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.deleteCateAsset(attr.assetID, index, category.assets)
          }
        }
      }, [_vm._v("\n              x\n            ")])])])
    })], 2)
  }), 0)]), _vm._v(" "), (_vm.showConfirmationModal) ? _c('div', {
    staticClass: "modal modal--confirmation fade",
    class: {
      in: _vm.showConfirmationModal
    },
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "confirmationModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.showConfirmationModal = false
      }
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "confirmationModalLabel"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.modalTitle) + "\n          ")])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.showConfirmationModal = false
      }
    }
  }, [_vm._v("\n            No\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.confirmFieldEdit
    }
  }, [_vm._v("\n            Yes\n          ")])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showConfirmationModal),
      expression: "showConfirmationModal"
    }],
    staticClass: "modal-backdrop fade",
    class: {
      in: _vm.showConfirmationModal
    },
    on: {
      "click": function($event) {
        _vm.showConfirmationModal = false
      }
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("General Configure")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Prime Duration\n            "), _c('small', [_vm._v("(Duration for Displaying Prime)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Test Duration\n            "), _c('small', [_vm._v("(Duration for Displaying Stimulus)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Feedback Duration\n            "), _c('small', [_vm._v("(Duration for Displaying Feedback Time)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Blank Interval\n            "), _c('small', [_vm._v("(Duration for stimulus's interval)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "assetsHeading"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Prime description")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Prime URL")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Prime Type")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 text-center"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Delete")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("\n        Principal Target (i.e. brand name or logo, category image or name)\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("Are you sure you want to change this field? Please make sure you consult the BSA team first.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46047d36","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pgnatConfig/PGnatConfig.vue
// module id = 46
// module chunks = 0